module ContractProfitFadePageModel

open Elmish
open Elmish.Bridge
open Model
open PortalLibs.Client.Components
open Shared
open PortalLibs.Client.Util
open PortalLibs.Shared.NewTable
open PortalLibs.Shared

type Model =
  { SearchboxValue: string option
    Contracts: ContractWithProfitFade list option
    TableState: NewTableNext.Model<ContractWithProfitFade, ContractWithProfitFadeField, unit>
    ExpandedContractProfitFades: ContractId list
    ContractProfitFades: Map<ContractId, ContractProfit list>
    Active: bool option }

type Msg =
  | Contracts of ContractWithProfitFade list
  | ContractsCount of int64
  | SearchboxChanged of string option
  | TableStateChanged of NewTableNext.Msg<ContractWithProfitFade, ContractWithProfitFadeField, unit>
  | ContractProfitFadeExpansionToggled of ContractId
  | ContractProfitFades of ContractId * ContractProfit list
  | ActiveChanged of bool option
  | ExecuteSearch of SearchType

let init () =
  { SearchboxValue = None
    Contracts = None
    TableState = { NewTableNext.init None with Sort = (Profit3MthDelta |> Desc |> Some) }
    ExpandedContractProfitFades = []
    ContractProfitFades = Map.empty
    Active = Some true },
  Cmd.none


let update msg model =
  match msg with
  | ExecuteSearch searchType ->
    let tableState = model.TableState

    let searchParams =
      { Query =
          [ match model.SearchboxValue
                  |> Option.noneIfEmptyStrOptTrim
              with
            | None -> ()
            | Some text -> { Field = Name; Query = Wildcard(text) }
            match model.Active with
            | None -> ()
            | Some boolVal ->
              { Field = IsActive
                Query = Equals(boolVal |> string) } ]
        Page = tableState.Page
        PageSize = tableState.PageSize
        Sort = tableState.Sort
        PageCount = false
        Totals = [] }

    match searchType with
    | Search ->
      let searchParamsPageReset =
        { searchParams with
            Page = 0
            PageCount = true }

      searchParamsPageReset
      |> RSContractWithProfitFades
      |> Bridge.Send

      { model with TableState = (tableState |> NewTableNext.resetModel) }, Cmd.none
    | TableStateChange ->
      searchParams
      |> RSContractWithProfitFades
      |> Bridge.Send

      model, Cmd.none
  | ContractsCount count -> { model with TableState = { model.TableState with TotalItems = count } }, Cmd.none
  | SearchboxChanged searchValue -> { model with SearchboxValue = searchValue }, Cmd.ofMsg (ExecuteSearch Search)
  | Contracts contracts ->
    { model with
        Contracts = Some contracts
        TableState = { model.TableState with IsLoading = false } },
    Cmd.none
  | TableStateChanged msg ->
    let newModel, newCmd, externalMsg =
      NewTableNext.update msg model.TableState

    { model with TableState = newModel },
    Cmd.batch [
      Cmd.map TableStateChanged newCmd
      match externalMsg with
      | NewTableNext.PagingOrSortChanged _ -> Cmd.ofMsg (ExecuteSearch TableStateChange)
      | _ -> Cmd.none
    ]
  | ContractProfitFadeExpansionToggled jobId ->
    let contracts =
      if List.contains jobId model.ExpandedContractProfitFades then
        model.ExpandedContractProfitFades
        |> List.filter (fun j -> j <> jobId)
      else
        if not (Map.containsKey jobId model.ContractProfitFades) then
          RSContractProfits jobId |> Bridge.Send

        scrollIntoView (sprintf "NewTable-ContractProfitFadePage-Row-%i" jobId)
        jobId :: model.ExpandedContractProfitFades

    { model with ExpandedContractProfitFades = contracts }, Cmd.none
  | ContractProfitFades (jobId, contracts) ->
    scrollIntoView (sprintf "NewTable-ContractProfitFadePage-Row-%i" jobId)

    { model with ContractProfitFades = Map.add jobId contracts model.ContractProfitFades }, Cmd.none
  | ActiveChanged v -> { model with Active = v }, Cmd.ofMsg (ExecuteSearch Search)

let getScrollValue () = getTableScrollPos ()

let restoreScrollPos pos = scrollTableToPos pos
